import type { ProjectLimits, Seller } from "@tasduvar/shared";
import type { Pricing } from "@tasduvar/engine";

export type ExportFormat = "pdf" | "pdf-image" | "docx" | "dxf" | "json" | "xlsx" | "csv";
export interface UsageEntry { at: string; projectName: string; wallCount: number; format: ExportFormat; projectId?: string }

export interface ProviderDefaults {
  material?: { gamma?: number; allowableCompression?: number; jointFriction?: number; jointCohesion?: number };
  seismic?: { r?: 2.0 | 1.5 | 1.0; level?: "DD-1" | "DD-2" | "DD-3" | "DD-4"; includeWallInertia?: boolean; includeBackfillInertia?: boolean; kvOnTotalPressure?: boolean; dynamicPointOfApplication?: "H/2" | "0.6H" };
  classic?: Partial<Record<"overturning" | "sliding" | "bearing" | "eccentricity" | "jointShear" | "jointEccentricity", { static: number; seismic: number }>>;
  gammaRdev?: number;
  gammaRdevSeismic?: number;
  bearingRatio?: number;
  passiveNeglectedDepth?: number;
  /** Yeni projelere kopyalanan poz / birim fiyat tablosu (keşif) */
  pricing?: Pricing;
}

export interface ProviderFeatures { docx: boolean; dxf: boolean; polygonMode: boolean; multiLayer: boolean; lineLoads: boolean; jointChecks: boolean; classicTable: boolean }

export interface ProviderSettings {
  version: 1;
  passwordHash: string;
  imagePdf: boolean;
  branding: { footerText: string; logoDataUrl?: string; softwareNote: string; watermark?: string };
  defaults: ProviderDefaults;
  features: ProviderFeatures;
  usageLog: UsageEntry[];
  /** Yalnız sunucu sürümünde (yönetici görür): havale bilgileri. */
  billing?: { iban: string; accountHolder: string; transferNote: string };
  /** Satıcı kimliği (ön bilgilendirme / mesafeli satış sözleşmesi); sunucu modunda herkese açık */
  seller?: Seller;
  /** Yalnız sunucu sürümünde (yönetici): bulutta kullanıcı başına proje sınırı */
  limits?: ProjectLimits;
}

export interface ProviderStore {
  get(): Promise<ProviderSettings>;
  set(s: ProviderSettings): Promise<void>;
  appendLog(e: UsageEntry): Promise<void>;
}

export const PASSWORD_SALT = "tasduvar-v1:";
/** sha256Hex(PASSWORD_SALT + "tasduvar") — ilk parola; panelden değiştirilir. */
export const DEFAULT_PASSWORD_HASH = "e4d8901edd3ca27cb687bf8d535dbf7a629aaac4b802f0854c0dba23422c6ebd";
export const MAX_LOG = 500;

export const DEFAULT_PROVIDER: ProviderSettings = {
  version: 1,
  passwordHash: DEFAULT_PASSWORD_HASH,
  imagePdf: false,
  branding: { footerText: "TaşDuvar — taş istinat duvarı analizi", softwareNote: "Bu rapor TaşDuvar yazılımı ile TBDY 2018 §16.12 esaslarına göre hazırlanmıştır.", watermark: "" },
  defaults: {},
  features: { docx: true, dxf: true, polygonMode: true, multiLayer: true, lineLoads: true, jointChecks: true, classicTable: true },
  usageLog: [],
};
